export enum KEYCODES {
  ArrowUp = 38,
  ArrowDown = 40,
  Enter = 13,
}
